export enum Spacing {
  NONE = 0,
  X_SMALL = 8,
  SMALL = 16,
  MEDIUM_SMALL = 20,
  MEDIUM = 24,
  LARGE = 32,
  X_LARGE = 40,
  XX_LARGE = 48,
}
